import { NgForOf, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageBadgeComponent } from '../language-badge/language-badge.component';

interface DialogData {
  setLanguage: (language: string) => string;
  languages: string[];
}

@Component({
  templateUrl: './language-picker-modal.component.html',
  styleUrls: ['./language-picker-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    TranslateModule,
    NgForOf,
    NgOptimizedImage,
    MatDialogModule,
    LanguageBadgeComponent,
  ],
})
export class LanguagePickerModalComponent {
  public readonly languages = this._data.languages;

  constructor(@Inject(MAT_DIALOG_DATA) private _data: DialogData) {}

  public setLanguage(language: string): void {
    this._data.setLanguage(language);
  }
}
